document.addEventListener("DOMContentLoaded", () => {
  const toggleBtn = document.querySelector(".collection-new-filter-toggle");
  const layout = document.querySelector(".collection-layout");
  let ALL_PRODUCTS_DATA = [];
  let isFilterActive = false;
  let currentPage = 1;
  let isLoading = false;
  let hasMorePages = document.getElementById("pagination-info")?.dataset.hasNext === "true";

  // Inisialisasi data produk
  function initializeProductsData() {
    const productElements = document.querySelectorAll("#all-products .product-item");
    ALL_PRODUCTS_DATA = Array.from(productElements).map((product, index) => ({
      id: `product-${index}`,
      title: product.dataset.title || '',
      big: product.dataset.big || 'false',
      pos: product.dataset.pos || '',
      html: product.outerHTML,
      displayed: true // Langsung ditandai sebagai ditampilkan
    }));
    console.log(`Initialized ${ALL_PRODUCTS_DATA.length} products`);
  }

  // Fungsi untuk membuat elemen DOM dari data produk
  function createProductElement(productData) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = productData.html;
    const productElement = tempDiv.firstElementChild;
    
    if (productData.title) productElement.dataset.title = productData.title;
    if (productData.big !== undefined) productElement.dataset.big = productData.big;
    if (productData.pos) productElement.dataset.pos = productData.pos;
    
    return productElement;
  }

  // Fungsi untuk load produk via AJAX
  async function loadMoreProducts() {
    if (isLoading || !hasMorePages) return;
    
    isLoading = true;
    currentPage++;
    
    const nextPageUrl = document.getElementById("pagination-info")?.dataset.nextPage;
    if (!nextPageUrl) {
      isLoading = false;
      return;
    }
    
    try {
      showLoadingIndicator();
      
      const response = await fetch(nextPageUrl);
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Ekstrak produk dari halaman baru
      const newProducts = doc.querySelectorAll("#all-products .product-item");
      const paginationInfo = doc.getElementById("pagination-info");
      
      // Update pagination info
      if (paginationInfo) {
        document.getElementById("pagination-info").dataset.nextPage = paginationInfo.dataset.nextPage;
        document.getElementById("pagination-info").dataset.hasNext = paginationInfo.dataset.hasNext;
        hasMorePages = paginationInfo.dataset.hasNext === "true";
      }
      
      // Simpan produk baru ke data
      Array.from(newProducts).forEach((product, index) => {
        ALL_PRODUCTS_DATA.push({
          id: `product-${ALL_PRODUCTS_DATA.length}-${Date.now()}`,
          title: product.dataset.title || '',
          big: product.dataset.big || 'false',
          pos: product.dataset.pos || '',
          html: product.outerHTML,
          displayed: false // BELUM DITAMPILKAN
        });
      });
      
      console.log(`Added ${newProducts.length} new products, total: ${ALL_PRODUCTS_DATA.length}`);
      
      // REBUILD GRID DARI AWAL dengan semua produk
      buildGrid(isFilterActive);
      
    } catch (error) {
      console.error("Error loading more products:", error);
      currentPage--;
    } finally {
      hideLoadingIndicator();
      isLoading = false;
      
      // Setup infinite scroll lagi
      setTimeout(() => {
        setupInfiniteScroll();
      }, 100);
    }
  }

  // Fungsi utama untuk build grid
  function buildGrid(isFilterActiveParam = false) {
    isFilterActive = isFilterActiveParam;
    
    console.log("Building grid with", ALL_PRODUCTS_DATA.length, "products, filter:", isFilterActive);
    
    // Buat array elemen DOM dari data
    const allElements = ALL_PRODUCTS_DATA.map(productData => createProductElement(productData));
    
    // Tandai semua sebagai ditampilkan
    ALL_PRODUCTS_DATA.forEach(product => {
      product.displayed = true;
    });
    
    if (!allElements.length) {
      console.error("No products to display");
      return;
    }
    
    // Pisahkan produk berdasarkan tipe
    const leftBig = allElements.filter(p => p.dataset.big == "true" && p.dataset.pos == "Left");
    const rightBig = allElements.filter(p => p.dataset.big == "true" && p.dataset.pos == "Right");
    const normal = allElements.filter(p => p.dataset.big != "true");
    
    console.log("leftBig:", leftBig.length, "rightBig:", rightBig.length, "normal:", normal.length);
    
    // Cek urutan: apakah right muncul lebih dulu dari left dalam data asli
    let rightComesFirst = false;
    if (leftBig.length === 0 && rightBig.length > 0) {
      // Jika left kosong, right harus di atas
      rightComesFirst = true;
    } else if (leftBig.length > 0 && rightBig.length > 0) {
      // Cek index pertama dari left dan right dalam allElements
      const firstLeftIndex = allElements.indexOf(leftBig[0]);
      const firstRightIndex = allElements.indexOf(rightBig[0]);
      // Jika right muncul lebih dulu (index lebih kecil), right harus di atas
      if (firstRightIndex !== -1 && firstLeftIndex !== -1 && firstRightIndex < firstLeftIndex) {
        rightComesFirst = true;
      }
    }
    
    let bl = 0, br = 0, n = 0;
    const finalGrid = document.querySelector("#final-grid");
    
    if (!finalGrid) {
      console.error("#final-grid not found");
      return;
    }
    
    // Kosongkan grid
    finalGrid.innerHTML = '';
    
    // Reset semua grid area
    allElements.forEach(product => {
      product.style.gridArea = '';
      product.style.width = '';
    });
    
    // --- TEMPLATE: PAIRED BIG CARDS SECTION (LEFT + RIGHT) ---
    function createPairedSection(leftBigEl, rightBigEl, normalStart, normalCount) {
      const sectionDiv = document.createElement('div');
      sectionDiv.className = 'grid-section';
      sectionDiv.style.display = 'grid';
      sectionDiv.style.marginBottom = '40px';
      sectionDiv.style.columnGap = '1px';
      sectionDiv.style.rowGap = '38px';
      
      if (isFilterActive) {
        // 3 KOLOM (FILTER AKTIF)
        sectionDiv.style.gridTemplateColumns = 'repeat(3, 1fr)';
        sectionDiv.style.gridTemplateRows = 'repeat(10, auto)';
        
        // Tambahkan left big
        leftBigEl.style.gridArea = '1 / 1 / 3 / 3';
        sectionDiv.appendChild(leftBigEl);
        
        // 2 normal di kanan left big
        if (n < normal.length) {
          normal[n].style.gridArea = '1 / 3 / 2 / 4';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        if (n < normal.length) {
          normal[n].style.gridArea = '2 / 3 / 3 / 4';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // Baris 3-5 (9 normal products)
        for (let row = 3; row <= 5; row++) {
          for (let col = 1; col <= 3; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
        
        // 2 normal di kiri right big
        if (n < normal.length) {
          normal[n].style.gridArea = '6 / 1 / 7 / 2';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        if (n < normal.length) {
          normal[n].style.gridArea = '7 / 1 / 8 / 2';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // Tambahkan right big
        rightBigEl.style.gridArea = '6 / 2 / 8 / 4';
        sectionDiv.appendChild(rightBigEl);
        
        // Baris 8-10 (9 normal products)
        for (let row = 8; row <= 10; row++) {
          for (let col = 1; col <= 3; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
        
      } else {
        // 4 KOLOM (FILTER NON-AKTIF)
        sectionDiv.style.gridTemplateColumns = 'repeat(4, 1fr)';
        sectionDiv.style.gridTemplateRows = 'repeat(10, auto)';
        
        // Tambahkan left big
        leftBigEl.style.gridArea = '1 / 1 / 3 / 3';
        sectionDiv.appendChild(leftBigEl);
        
        // 4 normal di kanan left big
        for (let i = 0; i < 4 && n < normal.length; i++) {
          const row = i < 2 ? 1 : 2;
          const col = i % 2 === 0 ? 3 : 4;
          normal[n].style.gridArea = `${row} / ${col}`;
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // Baris 3-5 (12 normal products)
        for (let row = 3; row <= 5; row++) {
          for (let col = 1; col <= 4; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
        
        // 4 normal di kiri right big
        for (let i = 0; i < 4 && n < normal.length; i++) {
          const row = i < 2 ? 6 : 7;
          const col = i % 2 === 0 ? 1 : 2;
          normal[n].style.gridArea = `${row} / ${col}`;
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // Tambahkan right big
        rightBigEl.style.gridArea = '6 / 3 / 8 / 5';
        sectionDiv.appendChild(rightBigEl);
        
        // Baris 8-10 (12 normal products)
        for (let row = 8; row <= 10; row++) {
          for (let col = 1; col <= 4; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
      }
      
      finalGrid.appendChild(sectionDiv);
    }
    
    // --- TEMPLATE: LEFT BIG ONLY SECTION ---
    function createLeftBigOnlySection(leftBigEl, normalStart, normalCount) {
      const sectionDiv = document.createElement('div');
      sectionDiv.className = 'grid-section';
      sectionDiv.style.display = 'grid';
      sectionDiv.style.marginBottom = '40px';
      sectionDiv.style.columnGap = '1px';
      sectionDiv.style.rowGap = '38px';
      
      if (isFilterActive) {
        // 3 KOLOM
        sectionDiv.style.gridTemplateColumns = 'repeat(3, 1fr)';
        sectionDiv.style.gridTemplateRows = 'repeat(6, auto)';
        
        leftBigEl.style.gridArea = '1 / 1 / 3 / 3';
        sectionDiv.appendChild(leftBigEl);
        
        // 2 normal di kanan left big
        if (n < normal.length) {
          normal[n].style.gridArea = '1 / 3 / 2 / 4';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        if (n < normal.length) {
          normal[n].style.gridArea = '2 / 3 / 3 / 4';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // 12 normal di bawah
        for (let row = 3; row <= 6; row++) {
          for (let col = 1; col <= 3; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
        
      } else {
        // 4 KOLOM
        sectionDiv.style.gridTemplateColumns = 'repeat(4, 1fr)';
        sectionDiv.style.gridTemplateRows = 'repeat(5, auto)';
        
        leftBigEl.style.gridArea = '1 / 1 / 3 / 3';
        sectionDiv.appendChild(leftBigEl);
        
        // 4 normal di kanan left big
        for (let i = 0; i < 4 && n < normal.length; i++) {
          const row = i < 2 ? 1 : 2;
          const col = i % 2 === 0 ? 3 : 4;
          normal[n].style.gridArea = `${row} / ${col}`;
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // 12 normal di bawah
        for (let row = 3; row <= 5; row++) {
          for (let col = 1; col <= 4; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
      }
      
      finalGrid.appendChild(sectionDiv);
    }
    
    // --- TEMPLATE: RIGHT BIG ONLY SECTION (RIGHT DI BAWAH) ---
    function createRightBigOnlySection(rightBigEl, normalStart, normalCount) {
      const sectionDiv = document.createElement('div');
      sectionDiv.className = 'grid-section';
      sectionDiv.style.display = 'grid';
      sectionDiv.style.marginBottom = '40px';
      sectionDiv.style.columnGap = '1px';
      sectionDiv.style.rowGap = '38px';
      
      if (isFilterActive) {
        // 3 KOLOM
        sectionDiv.style.gridTemplateColumns = 'repeat(3, 1fr)';
        sectionDiv.style.gridTemplateRows = 'repeat(6, auto)';
        
        // 12 normal di atas
        for (let row = 1; row <= 4; row++) {
          for (let col = 1; col <= 3; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
        
        // 2 normal di kiri right big
        if (n < normal.length) {
          normal[n].style.gridArea = '5 / 1 / 6 / 2';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        if (n < normal.length) {
          normal[n].style.gridArea = '6 / 1 / 7 / 2';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // Tambahkan right big di posisi kanan
        rightBigEl.style.gridArea = '5 / 2 / 7 / 4';
        sectionDiv.appendChild(rightBigEl);
        
      } else {
        // 4 KOLOM
        sectionDiv.style.gridTemplateColumns = 'repeat(4, 1fr)';
        sectionDiv.style.gridTemplateRows = 'repeat(5, auto)';
        
        // 12 normal di atas
        for (let row = 1; row <= 3; row++) {
          for (let col = 1; col <= 4; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
        
        // 4 normal di kiri right big
        for (let i = 0; i < 4 && n < normal.length; i++) {
          const row = i < 2 ? 4 : 5;
          const col = i % 2 === 0 ? 1 : 2;
          normal[n].style.gridArea = `${row} / ${col}`;
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // Tambahkan right big di posisi kanan
        rightBigEl.style.gridArea = '4 / 3 / 6 / 5';
        sectionDiv.appendChild(rightBigEl);
      }
      
      finalGrid.appendChild(sectionDiv);
    }
    
    // --- TEMPLATE: RIGHT BIG ONLY SECTION (RIGHT DI ATAS, TETAP DI POSISI KANAN) ---
    function createRightBigOnlySectionTop(rightBigEl, normalStart, normalCount) {
      const sectionDiv = document.createElement('div');
      sectionDiv.className = 'grid-section';
      sectionDiv.style.display = 'grid';
      sectionDiv.style.marginBottom = '40px';
      sectionDiv.style.columnGap = '1px';
      sectionDiv.style.rowGap = '38px';
      
      if (isFilterActive) {
        // 3 KOLOM
        sectionDiv.style.gridTemplateColumns = 'repeat(3, 1fr)';
        sectionDiv.style.gridTemplateRows = 'repeat(6, auto)';
        
        // Tambahkan right big di baris pertama, posisi kanan
        rightBigEl.style.gridArea = '1 / 2 / 3 / 4';
        sectionDiv.appendChild(rightBigEl);
        
        // 2 normal di kiri right big
        if (n < normal.length) {
          normal[n].style.gridArea = '1 / 1 / 2 / 2';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        if (n < normal.length) {
          normal[n].style.gridArea = '2 / 1 / 3 / 2';
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // 12 normal di bawah
        for (let row = 3; row <= 6; row++) {
          for (let col = 1; col <= 3; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
        
      } else {
        // 4 KOLOM
        sectionDiv.style.gridTemplateColumns = 'repeat(4, 1fr)';
        sectionDiv.style.gridTemplateRows = 'repeat(5, auto)';
        
        // Tambahkan right big di baris pertama, posisi kanan
        rightBigEl.style.gridArea = '1 / 3 / 3 / 5';
        sectionDiv.appendChild(rightBigEl);
        
        // 4 normal di kiri right big
        for (let i = 0; i < 4 && n < normal.length; i++) {
          const row = i < 2 ? 1 : 2;
          const col = i % 2 === 0 ? 1 : 2;
          normal[n].style.gridArea = `${row} / ${col}`;
          sectionDiv.appendChild(normal[n]);
          n++;
        }
        
        // 12 normal di bawah
        for (let row = 3; row <= 5; row++) {
          for (let col = 1; col <= 4; col++) {
            if (n < normal.length) {
              normal[n].style.gridArea = `${row} / ${col}`;
              sectionDiv.appendChild(normal[n]);
              n++;
            }
          }
        }
      }
      
      finalGrid.appendChild(sectionDiv);
    }
    
    // --- LOGIKA UTAMA: BUAT GRID DENGAN TEMPLATE ---
    // Jika right muncul lebih dulu atau left kosong, right harus di atas
    if (rightComesFirst) {
      // 1. BUAT RIGHT BIG ONLY DI ATAS (untuk right pertama)
      if (br < rightBig.length && n < normal.length) {
        createRightBigOnlySectionTop(rightBig[br], n, isFilterActive ? 14 : 16);
        br++;
      }
      
      // 2. BUAT PASANGAN BIG CARDS (LEFT + RIGHT) - untuk pasangan selanjutnya
      while (bl < leftBig.length && br < rightBig.length && n < normal.length) {
        createPairedSection(leftBig[bl], rightBig[br], n, isFilterActive ? 20 : 20);
        bl++;
        br++;
      }
      
      // 3. BUAT LEFT BIG ONLY (jika masih ada)
      while (bl < leftBig.length && n < normal.length) {
        createLeftBigOnlySection(leftBig[bl], n, isFilterActive ? 14 : 16);
        bl++;
      }
      
      // 4. BUAT RIGHT BIG ONLY DI BAWAH (jika masih ada right yang belum dipasangkan)
      while (br < rightBig.length && n < normal.length) {
        createRightBigOnlySection(rightBig[br], n, isFilterActive ? 14 : 16);
        br++;
      }
    } else {
      // Logika normal: left selalu di atas
      // 1. BUAT PASANGAN BIG CARDS (LEFT + RIGHT)
      while (bl < leftBig.length && br < rightBig.length && n < normal.length) {
        createPairedSection(leftBig[bl], rightBig[br], n, isFilterActive ? 20 : 20);
        bl++;
        br++;
      }
      
      // 2. BUAT LEFT BIG ONLY (jika masih ada)
      while (bl < leftBig.length && n < normal.length) {
        createLeftBigOnlySection(leftBig[bl], n, isFilterActive ? 14 : 16);
        bl++;
      }
      
      // 3. BUAT RIGHT BIG ONLY (jika masih ada)
      while (br < rightBig.length && n < normal.length) {
        createRightBigOnlySection(rightBig[br], n, isFilterActive ? 14 : 16);
        br++;
      }
    }
    
    // 4. SISA NORMAL PRODUCTS - BUAT GRID NORMAL
    if (n < normal.length) {
      const container = document.createElement('div');
      container.style.display = 'grid';
      container.style.gridTemplateColumns = isFilterActive ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)';
      container.style.columnGap = '1px';
      container.style.rowGap = '38px';
      container.style.marginBottom = '40px';
      
      // Tambahkan semua sisa normal products
      for (; n < normal.length; n++) {
        container.appendChild(normal[n]);
      }
      
      finalGrid.appendChild(container);
    }
    
    // 5. SISA BIG CARDS TANPA NORMAL PRODUCTS
    if (bl < leftBig.length || br < rightBig.length) {
      const remainingBigCards = [
        ...leftBig.slice(bl),
        ...rightBig.slice(br)
      ];
      
      remainingBigCards.forEach(bigCard => {
        const container = document.createElement('div');
        container.style.display = 'grid';
        container.style.gridTemplateColumns = isFilterActive ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)';
        container.style.columnGap = '1px';
        container.style.rowGap = '38px';
        container.style.marginBottom = '40px';
        
        // Atur big card menjadi 2x2 di kiri
        bigCard.style.gridArea = '1 / 1 / 3 / 3';
        container.appendChild(bigCard);
        
        finalGrid.appendChild(container);
      });
    }
    
    console.log("Grid built successfully. Products displayed:", 
      `leftBig: ${bl}, rightBig: ${br}, normal: ${n}`);
    
    // Setup infinite scroll
    setTimeout(() => {
      setupInfiniteScroll();
      // Re-initialize Swiper setelah produk ditambahkan
      reinitializeProductSwipers();
    }, 100);
  }

  // Fungsi untuk re-initialize Swiper setelah produk ditambahkan
  function reinitializeProductSwipers() {
    // Trigger custom event untuk memberitahu card-normal.liquid script
    const event = new CustomEvent('productsUpdated');
    document.dispatchEvent(event);
    
    // Juga langsung panggil init Swiper jika fungsi global tersedia
    if (typeof window.initProductCards === 'function') {
      setTimeout(() => {
        window.initProductCards();
      }, 150);
    }
  }

  // Fungsi untuk infinite scroll
  function setupInfiniteScroll() {
    if (window.infiniteScrollObserver) {
      window.infiniteScrollObserver.disconnect();
    }
    
    const options = {
      root: null,
      rootMargin: '300px',
      threshold: 0.1
    };
    
    window.infiniteScrollObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading && hasMorePages) {
          loadMoreProducts();
        }
      });
    }, options);
    
    let sentinel = document.getElementById("infinite-scroll-sentinel");
    if (!sentinel) {
      sentinel = document.createElement("div");
      sentinel.id = "infinite-scroll-sentinel";
      sentinel.style.height = "1px";
      sentinel.style.width = "100%";
      document.getElementById("final-grid").appendChild(sentinel);
    }
    
    window.infiniteScrollObserver.observe(sentinel);
  }

  // Fungsi loading indicator
  function showLoadingIndicator() {
    let loader = document.getElementById("infinite-scroll-loader");
    if (!loader) {
      loader = document.createElement("div");
      loader.id = "infinite-scroll-loader";
      loader.style.textAlign = "center";
      loader.style.padding = "40px 0";
      loader.innerHTML = `
        <div style="display: inline-block; width: 40px; height: 40px; border: 3px solid #f3f3f3; border-top: 3px solid #333; border-radius: 50%; animation: spin 1s linear infinite;"></div>
      `;
      document.getElementById("final-grid").appendChild(loader);
    }
  }

  function hideLoadingIndicator() {
    const loader = document.getElementById("infinite-scroll-loader");
    if (loader) loader.remove();
  }

  // **HAPUS BAGIAN YANG DUPLIKAT DI SINI - SIMPAN SATU SAJA**
  
  // Event listener untuk toggle filter (HANYA SATU KALI)
  if (toggleBtn && layout) {
    toggleBtn.addEventListener("click", () => {
      const isCurrentlyActive = layout.classList.contains("filter-active");
      
      if (isCurrentlyActive) {
        // Tutup filter
        layout.classList.remove("filter-active");
        setTimeout(() => {
          buildGrid(false);
        }, 50);
      } else {
        // Buka filter
        layout.classList.add("filter-active");
        setTimeout(() => {
          buildGrid(true);
        }, 50);
      }
      
      const isActive = layout.classList.contains("filter-active");
      toggleBtn.setAttribute("aria-clicked", isActive ? "true" : "false");
    });
    
    // Event listener untuk close button filter di dalam .filter-column
    const filterCloseBtn = document.querySelector(".filter-column .filter-toggle-close");
    if (filterCloseBtn) {
      filterCloseBtn.addEventListener("click", () => {
        // Hapus class filter-active dari layout
        layout.classList.remove("filter-active");
        
        // Update toggle button state
        toggleBtn.setAttribute("aria-clicked", "false");
        
        // Rebuild grid tanpa filter
        setTimeout(() => {
          buildGrid(false);
        }, 50);
      });
    }
    
    // Cari semua close button di dalam filter-column (jika ada lebih dari satu)
    const filterCloseButtons = document.querySelectorAll(".filter-column .filter-toggle-close");
    if (filterCloseButtons.length > 0) {
      filterCloseButtons.forEach(btn => {
        btn.addEventListener("click", () => {
          layout.classList.remove("filter-active");
          toggleBtn.setAttribute("aria-clicked", "false");
          setTimeout(() => {
            buildGrid(false);
          }, 50);
        });
      });
    }
    
    // Optional: Close filter ketika klik di luar filter column (overlay)
    if (layout) {
      document.addEventListener("click", (event) => {
        const filterColumn = document.querySelector(".filter-column");
        const isClickInsideFilter = filterColumn?.contains(event.target);
        const isClickOnToggleBtn = toggleBtn?.contains(event.target);
        
        // Cek apakah klik pada salah satu close button
        let isClickOnCloseBtn = false;
        filterCloseButtons.forEach(btn => {
          if (btn.contains(event.target)) {
            isClickOnCloseBtn = true;
          }
        });
        
        // Jika filter aktif, klik di luar filter column, dan bukan klik pada toggle/close button
        if (layout.classList.contains("filter-active") && 
            !isClickInsideFilter && 
            !isClickOnToggleBtn && 
            !isClickOnCloseBtn &&
            window.innerWidth < 1024) { // Hanya di mobile/tablet
          layout.classList.remove("filter-active");
          toggleBtn.setAttribute("aria-clicked", "false");
          setTimeout(() => {
            buildGrid(false);
          }, 50);
        }
      });
    }
  }

  // Tambahkan CSS untuk animasi
  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);

  // Inisialisasi dan build grid pertama kali
  initializeProductsData();
  buildGrid();
});

